<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps<{
  message: string;
  kind: 'success' | 'error' | 'info';
}>();
void props; // 模板里通过 $props / 解构隐式消费
const emit = defineEmits<{ close: [] }>();

const visible = ref(false);
let timer: ReturnType<typeof setTimeout> | null = null;

onMounted(() => {
  requestAnimationFrame(() => (visible.value = true));
  timer = setTimeout(() => emit('close'), 3500);
});

onBeforeUnmount(() => {
  if (timer) clearTimeout(timer);
});

const kindClass = {
  success: 'bg-success text-white',
  error: 'bg-danger text-white',
  info: 'bg-primary text-white',
};
</script>

<template>
  <div
    class="fixed right-4 top-20 z-50 max-w-sm rounded-xl px-4 py-3 shadow-elevated transition-all"
    :class="[kindClass[kind], visible ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0']"
    role="alert"
  >
    <div class="flex items-center gap-3">
      <span class="text-sm font-medium">{{ message }}</span>
      <button class="opacity-80 hover:opacity-100" aria-label="关闭" @click="emit('close')">✕</button>
    </div>
  </div>
</template>
